.alfredFooterRoot {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 20px;
}

.hidden {
  visibility: hidden;
}

.fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: var(--z-index-chat-input);
  background: transparent;
}

.sticky {
  position: sticky;
  bottom: 0;
  inset-inline: 0;
  z-index: 1;
}

.inputRegion {
  display: flex;
  align-items: center;
  justify-content: center;
  grid-column: 2;
  min-width: 300px;

  --chat-message-width: 1000px;
}
